import * as angular from 'angular';

import { MODULE_NAME } from '../config/constants';

// OTHER SERVICES
import ModalService from './ModalService';

angular.module(MODULE_NAME)
	.service('ModalService', ModalService);
